import {ReactNode} from "react";
import '../../assets/stylesheets/animations.css';
import useModal from "../../hooks/useModal.tsx";

interface SlidingModalProps {
  open: boolean,
  setOpen: (open: boolean) => void,
  children: ReactNode
}

export default function SlidingModal({ open, setOpen, children }: SlidingModalProps) {
  
  const { dialogRef } = useModal(open, setOpen);
  
  return (
    <dialog ref={dialogRef} className={'box-content z-50 fixed inset-[unset] right-0 top-0 height-screen m-0 w-full max-w-screen xs:w-[clamp(300px,40%,500px)] py-4 xs:py-6 px-0 xs:px-4 animation--sliding bg-[#F4F6F7]'}>
      <button className={'z-50 absolute right-6 top-6 hover:opacity-80 cursor-pointer'} onClick={() => setOpen(false)}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24">
          <path fill="#4F5E6B" transform="translate(3.40554 3.40554)"
                d="M1.6713786 0.28676322L8.5939999 7.2090001L15.517532 0.28676322C15.870472 -0.066176131 16.425831 -0.093325317 16.809912 0.20531569L16.902147 0.28676322C17.284498 0.66911423 17.284498 1.2890277 16.902147 1.6713786L9.9790001 8.5939999L16.902147 15.517532C17.284498 15.899883 17.284498 16.519796 16.902147 16.902147C16.519796 17.284498 15.899883 17.284498 15.517532 16.902147L8.5939999 9.9790001L1.6713786 16.902147C1.3184392 17.255087 0.76307982 17.282236 0.37899891 16.983595L0.28676322 16.902147C-0.095587745 16.519796 -0.095587745 15.899883 0.28676322 15.517532L7.2090001 8.5939999L0.28676322 1.6713786C-0.095587745 1.2890277 -0.095587745 0.66911423 0.28676322 0.28676322C0.66911423 -0.095587745 1.2890277 -0.095587745 1.6713786 0.28676322Z"
                fillRule="evenodd"/>
        </svg>
      </button>
      {children}
    </dialog>
  )
}